export default "__VITE_ASSET__DLuXetzC__"